import {z} from 'zod'
import {useFormContext} from 'react-hook-form'

import {useFileToJsonMutation} from '@sdox/api'
import {checkFileTextEncoding} from '@sdox/utils/dom'

import {TemplateForm} from '../TemplateForm'
import {FileUpload} from '../../../../FileUpload/FileUpload'

import type {DynamicFieldData, SelectFieldData} from '../../../../'

const createFieldNameInput = (name: string, ctx: string, options: string[]) => ({
  label: `${name} field name`,
  fieldName: `data.config.${ctx}`,
  inputType: 'select',
  options: [{label: '-- select --', value: ''}, ...options.map(v => ({label: v, value: v}))],
  defaultValue: '',
  required: true,
} as SelectFieldData)

const fieldNames = [
  ['Title', 'titleFieldName'],
  ['CTA', 'ctaFieldName'],
  ['Description', 'descriptionFieldName'],
  ['Additional', 'additionalFieldName'],
  ['Filter', 'filterFieldName'],
  ['Key visual', 'keyVisualFieldName'],
]

const inputFields: DynamicFieldData[] = [
  {
    label: 'Items',
    fieldName: 'data.rawItems',
    inputType: 'json',
    defaultValue: JSON.stringify([], null, 2),
    schema: z.array(z.object({})),
    required: true,
  },
  {
    label: 'Config',
    fieldName: 'data.config',
    inputType: 'json',
    defaultValue: JSON.stringify({}, null, 2),
    schema: z.object({}),
    required: true,
  },
  {
    label: 'Sections',
    fieldName: 'data.sections',
    inputType: 'json',
    defaultValue: JSON.stringify([], null, 2),
    schema: z.array(z.object({})),
    required: true,
  },
]

const getKeys = (value = '[]') => {
  const parsed = JSON.parse(value)

  if (typeof parsed !== 'object' || parsed === null) {
    return []
  }

  if (Array.isArray(parsed)) {
    return Object.keys(parsed[0])
  }

  return Object.keys(parsed)
}

export const DataSheetForm = () => {
  const {setValue, getValues} = useFormContext()
  const validate = async () => true as const

  const [fileToJsonMutation] = useFileToJsonMutation()

  const onUpload = async (file: File) => {
    //TODO maybe this logic should be moved to FileUpload with an optional codec prop?
    const isUtf8 = await checkFileTextEncoding(file, 'utf-8')
    if (!isUtf8){
      alert('Not a utf-8 file')
      return
    }
    // TODO error handling
    const data = await fileToJsonMutation({variables: {file}})
    const payload = data.data?.fileToJson ?? []
    setValue('data.rawItems', JSON.stringify(payload, null, 2))
    // TODO hardcoded fun :)
    setValue('data.config', JSON.stringify({
      titleFieldName: 'Fahrzeug',
      ctaFieldName: 'cta Label',
      keyVisualFieldName: 'keyVisualUrl',
      descriptionFieldName: null,
      additionalFieldName: null,
      filterFieldName: null,
    }, null, 2))
    setValue('data.sections', JSON.stringify([
      {
        sectionName: 'Motorisierung',
        items: [
          {
            label: {
              lookupType: 'STATIC',
              value: 'Leistung in PS',
              processors: [],
            },
            value: {
              lookupType: 'LOOKUP',
              value: 'field4',
              processors: [],
            },
          },
          {
            label: {
              lookupType: 'STATIC',
              value: 'Verbrauch l/100km',
              processors: [],
            },
            value: {
              lookupType: 'LOOKUP',
              value: 'field4',
              processors: [],
            },
          },
          {
            label: {
              lookupType: 'STATIC',
              value: 'Whatever',
              processors: [],
            },
            value: {
              lookupType: 'LOOKUP',
              value: 'field4',
              processors: [],
            },
          },
        ],
      }], null, 2))
  }

  // TODO add all keys to a dynamic dropdown input or as typing for the json editor?
  //const rawItemsKeys = getKeys(getValues('data.rawItems'))
  //const fieldNamesInputs = fieldNames.map(([name, ctx]) => createFieldNameInput(name, ctx, rawItemsKeys))

  return (
    <div className={'grid gap-spacing-16'}>
      <div>
        <label className={'font-medium'}>File Upload</label>
        <FileUpload
          onUpload={onUpload}
          validate={validate}
          accept={'*'}
        />
      </div>
      <TemplateForm inputFields={inputFields} />
    </div>
  )
}
